export enum OutputSettingTab {
    DO_TERMINALS = 'output-settings.tab.DO-terminals',
    AO_TERMINALS = 'output-settings.tab.AO-terminals',
}

export enum OutputSettingsType {
    UNDEFINED = 'undefined',
    DO = 'do',
    AO = 'ao',
}
